// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__32wiY","colMin":"styles_colMin__20ZHP","colCheckbox":"styles_colCheckbox__2qWQN"};